import React from 'react';
import { IconButton } from 'swag-client-common/components/ui/icon-button';
import { useHover } from 'swag-client-common/utils/hooks/use-hover.hook';
import { variables } from 'swag-client-common/styles/variables-js';
export const CustomizableIconButton = ({
  title,
  label,
  tooltipDirection,
  dataButton,
  dataTooltip,
  primaryColor,
  secondaryColor,
  buttonClassName,
  tooltipClassName,
  titleClassName,
  iconClassName,
  labelClassName,
  PrimaryIcon,
  SecondaryIcon,
  onClick
}) => {
  const [hovered, {
    onMouseOut,
    onMouseOver
  }] = useHover();
  const customChild = hovered ? /*#__PURE__*/React.createElement(SecondaryIcon, {
    className: iconClassName,
    svgColor: variables.colorWhite
  }) : /*#__PURE__*/React.createElement(PrimaryIcon, {
    className: iconClassName,
    svgColor: variables.colorWhite
  });
  const buttonStyles = {
    backgroundColor: hovered ? secondaryColor : primaryColor
  };
  const textStyles = {
    color: primaryColor
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    dataButton: dataButton,
    dataTooltip: dataTooltip,
    tooltipDirection: tooltipDirection,
    buttonClassName: buttonClassName,
    tooltipClassName: tooltipClassName,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver,
    buttonStyles: buttonStyles,
    customChild: customChild,
    onClick: onClick
  }), /*#__PURE__*/React.createElement("span", {
    className: labelClassName,
    style: textStyles
  }, label), title && /*#__PURE__*/React.createElement("span", {
    className: titleClassName,
    style: textStyles
  }, title));
};